import { useRecoilState, useSetRecoilState } from 'recoil';
import { cartAtom } from '../../../atoms/cartAtom';
import { notificationsAtom } from '../../../atoms/notificationsAtom';
import { initCommerceApiWithGlobals } from 'common-api';
import { cartNotification } from '../../../helpers/cartNotification';
import { logger } from 'common-ui';

export function useActionBatchAddToCart() {
  const setCartData = useSetRecoilState(cartAtom);
  const [, setNotification] = useRecoilState(notificationsAtom);

  return async (cartItems: any): Promise<void> => {
    try {
      const commerceApi = initCommerceApiWithGlobals();
      const newCartData = await commerceApi.Cart.batch(cartItems);
      if (newCartData) {
        setCartData(prevState => ({
          ...prevState,
          cartIsLoaded: true,
          cartItems: {
            ...prevState.cartItems,
            ...newCartData,
          },
        }));
        const fallbackItem = cartItems.cartItems[1] || cartItems.cartItems[0] || {};
        const { itemCode, quantity } = fallbackItem;
        const notification = cartNotification(itemCode, quantity);
        setNotification([notification]);
      }
    } catch (error) {
      logger.error('API ERROR', error);
      throw error;
    }
  };
}
